import styled from 'styled-components';

const Spinner = styled.div`
  &,
  &::after {
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }

  & {
    position: relative;
    text-indent: -9999em;
    border-top: 4px solid var(--chakra-colors-gray-200);
    border-right: 4px solid var(--chakra-colors-gray-200);
    border-bottom: 4px solid var(--chakra-colors-gray-200);
    border-left: 4px solid var(--chakra-colors-gray-600);
    transform: translateZ(0);
    animation: loading 1.1s infinite linear;
  }

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner;
